import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaFacebookF, FaLinkedin } from "react-icons/fa";
import { AiFillGithub, AiOutlineTwitter } from "react-icons/ai";
import { useSelector } from "react-redux";
import { AiFillShopping, AiFillHeart } from "react-icons/ai";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import toast from "react-hot-toast"; // Import toast for notifications

const Footer = () => {
  const { card_product_count, wishlist_count } = useSelector(
    (state) => state.card
  );
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);

  // State for email input
  const [email, setEmail] = useState("");

  // Handle subscription
  const handleSubscribe = () => {
    if (email) {
      // Clear the email input
      setEmail("");

      // Show a toast notification
      toast.success("Subscribed!");
    } else {
      // Show an error toast if the email is empty
      toast.error("Please enter a valid email.");
    }
  };

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="w-[85%] flex flex-wrap mx-auto py-16 sm:gap-10 md-lg:pb-10 sm:pb-6">
        <div className="w-3/12 lg:w-4/12 sm:w-full">
          <div className="flex flex-col gap-5">
            <img
              className="w-[80px] h-auto"
              src={`${process.env.REACT_APP_URL}/images/omahlogoupdated.png`}
              alt="logo"
            />
            <ul className="flex flex-col gap-2 text-gray-500 text-sm">
              <li>Email - support@omaglobal.com</li>
            </ul>
          </div>
        </div>
        <div className="w-5/12 lg:w-8/12 sm:w-full">
          <div className="flex justify-center sm:justify-start sm:mt-6 w-full">
            <div>
              <h2 className="font-bold text-lg mb-3">Company</h2>
              <div className="flex justify-between gap-[80px] lg:gap-[40px]">
                <ul className="flex flex-col gap-2 text-gray-500 text-sm">
                  <li>
                    <Link to="/about-us">About Us</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/return-refund-policy">Return & Refund Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-and-conditions">Terms & Conditions</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="w-4/12 lg:w-full lg:mt-6">
          <div className="w-full flex flex-col justify-start gap-3">
            <h2 className="font-bold text-lg text-gray-900">Get updates from us</h2>
            <span className="text-gray-500 text-sm">
              Get email updates about our latest and shop specials offers
            </span>
            <div className="flex w-full max-w-sm items-center space-x-2">
              <Input
                type="email"
                placeholder="Enter your email"
                className="rounded-full focus-visible:border-foreground"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Button type="submit" onClick={handleSubscribe}>
                Subscribe
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="w-[85%] flex flex-wrap justify-center items-center text-gray-400 mx-auto py-5 text-center text-sm">
        <span>Copiright ©2025 All rights reserved </span>
      </div>
    </footer>
  );
};

export default Footer;